import { render, staticRenderFns } from "./mainLoader.vue?vue&type=template&id=11281510&"
import script from "./mainLoader.vue?vue&type=script&lang=js&"
export * from "./mainLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports